import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/fields/add/draw")({
    component: RouteComponent,
});

function RouteComponent() {
    return <div>Hello "/dashboard/fields/add/draw"!</div>;
}
